import React from 'react';
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import TabContainer from "./TabContainer";
import QuizListSection from '../../components/QuizList/QuizListSection';
import SimpleSelect from "../../components/reactSelect";
import QuestionList from "../../components/QuestionList/questionList";
import NoData from "../common/Nodata/noData";
import { useNavigate } from 'react-router-dom';

/**
 * All test container.
 * @param props
 * @returns {*}
 * @constructor
 */

function FavoriteItemsContainer(props) {
    const {
        savedQuizList,
        questionLength,
        filterQuestions,
        totalQuestions,
        questionList,
        questionsLoading,
        selectedIndex,
        history
    } = props;
    const t = useTranslations();
    const navigate = useNavigate();
    function gotoPage() {
        let url = '/my-app/tests';
        navigate(url);
    }

    return (
        <div>
            {selectedIndex === 0 &&
            <TabContainer className="SavedQuiz">
                {savedQuizList && savedQuizList.length > 0 ?
                    <QuizListSection hideViewMore={false} quizSectionList={savedQuizList} showVertical={true}/>
                    :
                    <NoData message={t('you_have_not_saved_any_quiz')}
                            buttonText={t('go_to_quizzes')}
                            handleTabChange={() => gotoPage()}/>
                }

            </TabContainer>
            }
            {selectedIndex === 1 &&
            <TabContainer className="Attempted">
                <div className="saved-question-section">
                    <div className="saved-question-heading">
                        {questionLength ? <SimpleSelect t={t} onSelectChange={filterQuestions}/> : null}
                    </div>

                    <div className="saved-question-list">
                        <QuestionList totalQuestions={totalQuestions} questionList={questionList}
                                      singleQuesUrl={'/my-app/saved-questions/'}
                                      questionsLoading={questionsLoading} history={history}/>
                    </div>
                </div>
            </TabContainer>
            }
        </div>
    );
}

export default FavoriteItemsContainer;
